export default "__VITE_ASSET__bzSb1xXQ__"